import { render } from "./EndPassForm.vue?vue&type=template&id=ec876124"
import script from "./EndPassForm.vue?vue&type=script&lang=js"
export * from "./EndPassForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__